query GetMatchCampaignCategories {
  matchCampaignCategories {
    id
    name
    tagText
    icon
    colour
    showAgainstTransactions
  }
}
